let store = null

export const setStore = s => {
  store = s
}

export const getStore = () => {
  return store
}

export default {}
